var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module"},[_c('ScrollList',{staticClass:"service",attrs:{"items":_vm.items,"cols":4},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var card = ref.card;
return [_c('h4',[_vm._v(_vm._s(card.name))]),_c('b-card-text',{staticClass:"desc",attrs:{"title":card.desc},domProps:{"innerHTML":_vm._s(card.desc)}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }